module.exports = __webpack_public_path__ + "static/example_multiweek-a7cda68a873a673a01f9dbeb773a4a2f.png";